import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, of } from 'rxjs';
import { User } from 'projects/shared/src/public-api';

@Component({
  selector: 'lib-user-picker',
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.scss'],
  standalone: false,
})
export class UserPickerComponent implements OnInit {
  private translate = inject(TranslateService);

  constructor() {}

  @Input()
  preselectedUsers: string[] | string;
  @Input()
  users: Observable<User[]>;
  @Input()
  multiple: boolean;
  @Input()
  showAllEntry: boolean;
  @Input()
  isResponsible: boolean;
  @Input()
  isDriver: boolean;
  @Input()
  disabled: boolean = false;
  @Output()
  selectedUserChanged: EventEmitter<string> = new EventEmitter<string>();
  filteredUsers: Observable<User[]>;

  ngOnInit() {
    this.filteredUsers = this.users?.pipe(
      map((x) => x?.filter((y) => !y.isDeleted))
    );
  }

  getLabel() {
    if (this.isDriver) return this.translate.instant('user.driver');
    return this.translate.instant(
      this.isResponsible ? 'user.responsible' : 'user.type.employee'
    );
  }

  getPreselectedUser(): any {
    if (this.preselectedUsers != null) return of(this.preselectedUsers);
    return this.users.pipe(
      map((x) => {
        return x?.length == 1 ? x[0].userName : null;
      })
    );
  }
}
